import { render, staticRenderFns } from "./DetailAuthForm.vue?vue&type=template&id=083728ee&scoped=true"
import script from "./DetailAuthForm.vue?vue&type=script&lang=js"
export * from "./DetailAuthForm.vue?vue&type=script&lang=js"
import style0 from "./DetailAuthForm.vue?vue&type=style&index=0&id=083728ee&prod&scoped=true&lang=css"
import style1 from "./DetailAuthForm.vue?vue&type=style&index=1&id=083728ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083728ee",
  null
  
)

export default component.exports